exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-exchange {\n  padding-right: 20px;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column; }\n  .create-exchange :disabled {\n    opacity: 0.3;\n    cursor: auto; }\n", ""]);

// exports
